[
  {
    "type": "crystal_audit",
    "title": "Audit",
    "fieldSets": null,
    "isExpanded": true,
    "description": "",
    "subReports": [
      {
        "type": "au01",
        "title": "AU01 - Royalty Statement Data",
        "description": "Client Royalty Data",
        "fieldSets": null,
        "subReports": [],
        "isExpanded": false,
        "isProdReady": true
      },
      {
        "type": "au02",
        "title": "AU02 - Source and Earnings Detail Analysis",
        "description": "Source lines and associated earnings lines detail for audit and general inquires ",
        "fieldSets": null,
        "subReports": [],
        "isExpanded": false,
        "isProdReady": true
      }
    ]
  },
  {
    "type": "crystal_global_royalties",
    "title": "Global Royalties",
    "fieldSets": null,
    "isExpanded": true,
    "description": "",
    "subReports": [
      {
        "type": "gr05",
        "title": "GR05 - Statement Line Earnings Lines Details",
        "description": "This is a BIG DUMP of the SL and if it's been through a Royalty Calculation then it includes the Associated EL's",
        "fieldSets": null,
        "subReports": [],
        "isExpanded": false,
        "isProdReady": true
      },
      {
        "type": "gr07",
        "title": "GR07 - Statement Line Status Report",
        "description": "GR07 - Statement Line Status Report",
        "fieldSets": null,
        "subReports": [],
        "isExpanded": false,
        "isProdReady": true
      },
      {
        "type": "gr16m",
        "title": "GR16M - GRC multiple PO",
        "description": "GR16M - GRC multiple PO",
        "fieldSets": null,
        "subReports": [],
        "isExpanded": false
      },
      {
        "type": "gr19",
        "title": "GR19 - Global Suspense Consolidated Working File",
        "description": "GR19 - Global Suspense Consolidated Working File",
        "fieldSets": null,
        "subReports": [],
        "isExpanded": false
      }
    ]
  },
  {
    "type": "crystal_statement",
    "title": "Statements",
    "fieldSets": null,
    "isExpanded": true,
    "description": "",
    "subReports": [
      {
        "type": "cs01",
        "title": "CS01 - Client Statement",
        "description": "For replicating full client statements in PDF",
        "fieldSets": null,
        "subReports": [],
        "isExpanded": false
      },
      {
        "type": "cs04",
        "title": "CS04 - Royalty Statement",
        "description": "For creating an Excel report showing client royalty lines",
        "fieldSets": null,
        "subReports": [],
        "isExpanded": false,
        "isProdReady": true
      },
      {
        "type": "cs04g",
        "title": "CS04G - Royalty Statement Consolidation Group",
        "description": "For creating an Excel report showing client royalty lines by Consolidation Group",
        "fieldSets": null,
        "subReports": [],
        "isExpanded": false,
        "isProdReady": true
      },
      {
        "type": "cs05",
        "title": "CS05 - Production Statement",
        "description": "CS05 - Production Statement",
        "fieldSets": null,
        "subReports": [],
        "isExpanded": false,
        "isProdReady": true
      },
      {
        "type": "cs05d",
        "title": "CS05D - Production Statement",
        "description": "CS05D - Production Statement",
        "fieldSets": null,
        "subReports": [],
        "isExpanded": false,
        "isProdReady": true
      }
    ]
  },
  {
    "type": "cyrstal_royalty_admin",
    "title": "Royalty Admin",
    "fieldSets": null,
    "isExpanded": true,
    "description": "",
    "subReports": [
      {
        "type": "ra01",
        "title": "RA01 - Revenue Earnings NPS By Client - Admin",
        "description": "Income generated, Royalties due and NPS by client - ADMIN",
        "fieldSets": null,
        "subReports": [],
        "isExpanded": false,
        "isProdReady": true
      },
      {
        "type": "ra02",
        "title": "RA02 - Revenue Earnings NPS By Song or Production - Admin",
        "description": "Income generated, Royalties due and NPS by song or production - ADMIN",
        "fieldSets": null,
        "subReports": [],
        "isExpanded": false,
        "isProdReady": true
      },
      {
        "type": "ra03",
        "title": "RA03 - Revenue Earnings NPS By Company - Admin",
        "description": "Income generated, Royalties due and NPS by company - ADMIN",
        "fieldSets": null,
        "subReports": [],
        "isExpanded": false,
        "isProdReady": true
      },
      {
        "type": "ra04",
        "title": "RA04 - Revenue Earnings NPS By Source - Admin",
        "description": "Income generated, Royalties due and NPS by Source - ADMIN",
        "fieldSets": null,
        "subReports": [],
        "isExpanded": false,
        "isProdReady": true
      },
      {
        "type": "ra07",
        "title": "RA07 - Top Earning Songs",
        "description": "Top earning songs",
        "fieldSets": null,
        "subReports": [],
        "isExpanded": false
      },
      {
        "type": "ra24",
        "title": "RA24 - Check Registry Expanded",
        "description": "All payments set to be fed to AP for credit balance payments at the end of a royalty period. It's used as a backup for approvals from upper mgt and BA prior to checks being generated by AP",
        "fieldSets": null,
        "subReports": [],
        "isExpanded": false
      },
      {
        "type": "ra27",
        "title": "RA27 - Pipeline Report",
        "description": "Pipeline Earnings Report",
        "fieldSets": null,
        "subReports": [],
        "isExpanded": false
      }
    ]
  },
  {
    "type": "crystal_income_tracking",
    "title": "Income Tracking",
    "fieldSets": null,
    "isExpanded": true,
    "description": "",
    "subReports": [
      {
        "type": "it02",
        "title": "IT02 - Expected Income Report",
        "description": "Report is based off one of two tables in Income Tracking - Expected Income (various income types) or Expected Performance Income (specific to performance income type group). User selects one of two tables as a basis prior to running report and expected values are compared to the sum of Income Tracking Gross SL Amounts.",
        "fieldSets": null,
        "subReports": [],
        "isExpanded": false
      }
    ]
  },
  {
    "type": "crystal_charts",
    "title": "Charts",
    "fieldSets": null,
    "isExpanded": true,
    "description": "",
    "subReports": [
      {
        "type": "ch06",
        "title": "CH06 - Single Performance Activity (Radio)",
        "description": "Radio performance of top singles over a specific duration of time",
        "fieldSets": null,
        "subReports": [],
        "isExpanded": false
      },
      {
        "type": "ch07",
        "title": "CH07 - Single Performance Activity (Digital)",
        "description": "Digital performance of top singles over a specific duration of time",
        "fieldSets": null,
        "subReports": [],
        "isExpanded": false
      },
      {
        "type": "ch08",
        "title": "CH08 - Single Status",
        "description": "Review the match status of chart song singles listed for LTD, Nielsen Digital Streams, Nielsen BDS Radio Play and Billboard Singles",
        "fieldSets": null,
        "subReports": [],
        "isExpanded": false
      }
    ]
  },
  {
    "type": "crystal_financial",
    "title": "Financial",
    "fieldSets": null,
    "isExpanded": true,
    "description": "",
    "subReports": [
      {
        "type": "at18e",
        "title": "AT18E - Client Statement Trial Balance - Expanded",
        "description": "Report of balances, FTs and Royalties earned during statement period by client - EXPANDED",
        "fieldSets": null,
        "subReports": [],
        "isExpanded": false
      }
    ]
  },
  {
    "type": "crystal_copyright",
    "title": "Copyright",
    "fieldSets": null,
    "isExpanded": true,
    "description": "",
    "subReports": [
      {
        "type": "cr01",
        "title": "CR01 - Songs - Detailed",
        "description": "Detailed song report",
        "fieldSets": null,
        "subReports": [],
        "isExpanded": false
      }
    ]
  },
    {
    "type": "crystal_qa_utility",
    "title": "QA Reporting Utility",
    "fieldSets": null,
    "isExpanded": true,
    "description": "",
    "subReports": [
      {
        "type": "generate",
        "title": "Reports Generation",
        "description": "",
        "fieldSets": null,
        "subReports": [],
        "isExpanded": false,
        "isProdReady": true
      },
      {
        "type": "history",
        "title": "Reports History",
        "description": "",
        "fieldSets": null,
        "subReports": [],
        "isExpanded": false,
        "isProdReady": true
      }
    ]
  }
]